import React from "react";
import "../../css/aboutMe.css";

class NowSection extends React.Component {
  render() {
    return (
      <div className="now-section">
        <h2 className="now-title">📌 Now</h2>
        <ul className="now-list">
          <li>
            Submitted MSc thesis:{" "}
            <em>
              “Cross-Platform Privacy Tool for Facebook: Architecture and
              Implementation.”
            </em>
          </li>
          <li>Applying for graduation from Tampere University.</li>
          <li>
            Working part-time at <strong>Superwider</strong> as a full-stack
            developer (Next.js / TypeScript).
          </li>
          <li>
            Expanding and maintaining{" "}
            <a href="https://ibtehaz.xyz" target="_blank" rel="noreferrer">
              ibtehaz.xyz
            </a>{" "}
            — my personal site and playground.
          </li>
          <li>
            Spending more time offline, reading old books and watching slow
            films.
          </li>
        </ul>
      </div>
    );
  }
}

export default NowSection;
